import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Select } from "@mui/material";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination"; // For pagination
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { Options } from "assets/svgs/Icons";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useDashboard } from "context/DashboardContext";
import SimpleBackdrop from "layouts/authentication/backdrop";
import { useState } from "react";
import CreateCharge from "./create-charge";
import EditBillDialog from "./edit-bill";
import CreateTeamDialog from "./popup";

export default function SetChargesTable() {
  const { allMerchants, allMerchantError, loading } = useDashboard(); // Get all merchants and loading/error states
  const [selectedRow, setSelectedRow] = useState(null);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isCreateChargeOpen, setIsCreateChargeOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditBillDialogOpen, setIsEditBillDialogOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [isError, setIsError] = useState(true);
  const [searchName, setSearchName] = useState("");

  // Pagination state
  const [page, setPage] = useState(1); // Default page 1
  const [pageSize, setPageSize] = useState(10); // Default page size 10

  // Function to handle dropdown actions (Edit, etc)
  const handleActionsClick = (event, row) => {
    event.stopPropagation();
    setCurrentRow(row);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const handleEditRowClick = (event) => {
    event.stopPropagation();
    setSelectedRow(currentRow);
    setIsCreateChargeOpen(true);
    handleCloseDropdown();
  };

  const handleCloseEditBillDialog = () => {
    setIsCreateChargeOpen(false);
    setSelectedRow(null);
  };

  const filteredMerchants = (allMerchants || []).filter((row) => {
    const query = searchName.trim().toLowerCase();
    if (!query) return true;

    const merchant = row.merchant || {};
    const searchableNames = [
      merchant.name,
      merchant.businessName,
      merchant.merchantExt?.businessName,
      row.businessName,
      row.merchantExt?.businessName,
    ];

    return searchableNames.some((name) =>
      String(name || "").toLowerCase().includes(query),
    );
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredMerchants.length / pageSize);

  const paginatedMerchants = filteredMerchants.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const handlePageChange = (event, value) => {
    setPage(value); // Change the page when pagination button is clicked
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value); // Change the page size
    setPage(1); // Reset to page 1 when size changes
  };

  return (
    <SoftBox>
      <SoftBox
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1rem",
          marginTop: "3rem",
        }}
      >
        <h3>Set Charges</h3>
        <Button
          onClick={() => {
            setSelectedRow(null);
            setIsCreateChargeOpen(true);
          }}
        >
          Create Charge
        </Button>
      </SoftBox>
      <SoftBox display='flex' justifyContent='flex-start' px={1} mb={2}>
        <TextField
          placeholder='Search by name'
          variant='outlined'
          size='small'
          value={searchName}
          onChange={(event) => {
            setSearchName(event.target.value);
            setPage(1);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <SearchIcon color='primary' />
              </InputAdornment>
            ),
          }}
        />
      </SoftBox>
      <SoftBox>
        {loading ? (
          <SimpleBackdrop open={loading} />
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label='simple table' stickyHeader>
              <TableHead style={{ width: "100%" }}>
                <TableRow>
                  <TableCell>SN</TableCell>
                  <TableCell>Merchant Name</TableCell>
                  <TableCell>Fee Bearer</TableCell>
                  <TableCell>Fee</TableCell>
                  <TableCell>Mode</TableCell>
                  {/* <TableCell>Card Fee Bearer</TableCell> */}
                  {/* <TableCell>Card Fee</TableCell> */}
                  <TableCell>Max Amount</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedMerchants?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component='th' scope='row'>
                      {row.merchant.id}
                    </TableCell>
                    <TableCell>{row.merchant.name}</TableCell>
                    <TableCell>{row.merchant.feeBearer}</TableCell>
                    <TableCell>{row.merchant.fee}</TableCell>
                    <TableCell>
                      {row.merchant.feeByPercentage ? "Percentage" : "Fixed"}
                    </TableCell>
                    {/* <TableCell>{row.merchant.cardFeeBearer}</TableCell> */}
                    {/* <TableCell>{row.merchant.cardFee}</TableCell> */}
                    <TableCell>
                      {row.merchant.feeByPercentage
                        ? row.merchant.maxFeeAmount
                        : 0}
                    </TableCell>
                    <TableCell>
                      <Button onClick={(e) => handleActionsClick(e, row)}>
                        <Options />
                      </Button>
                      <Menu
                        id={`menu-${index}`}
                        anchorEl={anchorEl}
                        keepMounted
                        open={
                          Boolean(anchorEl) &&
                          currentRow?.merchant.id === row.merchant.id
                        }
                        onClose={handleCloseDropdown}
                      >
                        <MenuItem
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={handleEditRowClick}
                        >
                          Edit
                        </MenuItem>
                        {/* <MenuItem onClick={() => console.log("Delete clicked")}>
                          Delete
                        </MenuItem> */}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <CreateTeamDialog
          isOpen={isCreateDialogOpen}
          handleClose={() => setIsCreateDialogOpen(false)}
          rowData={selectedRow}
        />

        <CreateCharge
          isOpen={isCreateChargeOpen}
          handleClose={() => setIsCreateChargeOpen(false)}
          rowData={selectedRow}
          refresh={() => {}}
        />
        <EditBillDialog
          isOpen={isEditBillDialogOpen}
          handleClose={handleCloseEditBillDialog}
          rowData={selectedRow}
        />
      </SoftBox>

      {/* PAGINATION */}
      <SoftBox
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        width='100%'
        py={2}
        px={2}
      >
        {/* Pagination Controls */}
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          shape='rounded'
          color='primary'
        />

        {/* Page Size Selector */}
        <SoftBox display='flex' alignItems='center' gap={1}>
          <SoftTypography variant='caption'>Items/page:</SoftTypography>
          <Select
            value={pageSize}
            onChange={handlePageSizeChange}
            size='small'
            style={{ height: 20 }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={70}>70</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}
